/** Checks if the bitwise flag has a specific flag. */
export function hasFlag<T extends number>(flags: T, flagToCheck: T): boolean {
    return (flags & flagToCheck) === flagToCheck;
}

/** Checks if the bitwise flag has a specific flag and is not empty. */
export function hasNonEmptyFlag<T extends number>(flags: T | undefined | null, flagToCheck: T): boolean {
    return !!flags && hasFlag(flags, flagToCheck);
}
